import * as Yup from "yup";
import i18n from "../i18n";

export const GatesSchema = Yup.object({
  gateNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Gate Name (English) is required"
      : "اسم البوابة (باللغة الإنجليزية) مطلوب"
  ),
  gateNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Gate Name (Arabic) is required"
      : "اسم البوابة (عربي) مطلوب"
  ),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required" : "الموقع مطلوب"
  ),
  building: Yup.string().required(
    i18n.language === "en" ? "Building is required" : "مطلوب بناء"
  ),
});
